import React from 'react';
import {
    Select,
    TextField,
    Stack,
    Popover,
    DatePicker,
    Icon
} from '@shopify/polaris';
import {
    CalendarMajor
} from '@shopify/polaris-icons';
import { SelectFilterTypes } from '../common/Helpers';

const dateConditions = [
    { label: 'is ', value: 'EqualTo' },
    { label: 'is not', value: 'NotEqualTo' },
    { label: 'is after', value: 'GreaterThan' },
    { label: 'is or after', value: 'GreaterThanOrEqual' },
    { label: 'is or before', value: 'LessThanOrEqual' },
    { label: 'is before', value: 'LessThan' }
];

class ProductUpdatedAtFilterComponent extends React.Component {

    constructor(props) {
        super(props)

            this.state = {
                popoverActive: false,
                month: new Date().getMonth(),
                year: new Date().getFullYear(),
            }
    }

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={dateConditions}
                    value={this.props.filter.operator}
                    onChange={(selected) => this.onConditionChange(selected)}
                />
                <div data-polaris-layer style={{ position: 'relative', 'z-index': 1 }} >
                    <Popover
                        sectioned={true}
                        active={this.state.popoverActive}
                        onClose={() => this.toggleDateActive(false)}
                        activator={<TextField placeholder="Date"
                            prefix={<Icon source={CalendarMajor}></Icon>}
                            value={this.props.filter.value}
                            onFocus={() => this.toggleDateActive(true)}
                            onChange={(newValue) => this.onDateChange(newValue)} />}
                    >
                        <div>
                            <DatePicker
                                month={this.state.month}
                                year={this.state.year}
                                weekStartsOn={1}
                                selected={new Date(this.props.filter.value)}
                                onMonthChange={(month, year) => this.onMonthChange(month, year)}
                                onChange={(date) => this.onDateChange(date.start)}
                            />
                        </div>
                    </Popover>
                </div>
            </Stack>
        );
    }

    toggleDateActive = (active) => {
        this.setState({
            popoverActive: active
        })
    }

    onMonthChange = (month, year) => {
        this.setState({
            month: month,
            year: year
        })
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.operator = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onDateChange = (newValue) => {
        let utcDate = new Date(Date.UTC(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), 1, 1, 1));
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.value = utcDate.toISOString().substr(0, 10);

        this.props.onFilterUpdated(newFilter);
        this.toggleDateActive(false);
    }
}

export default ProductUpdatedAtFilterComponent;
